// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"H3-z","dimensionLabel":"I3-z","styleChooserControlWrapper":"J3-z","styleChooserControl":"K3-z","disabled":"L3-z","giftCard":"M3-z","styleChooserText":"N3-z"};